import React from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

type OptionFieldProps = {
  label: string;
  value: number;
};

function OptionField({ label, value }: OptionFieldProps) {
  return (
    <>
      <Grid item xs={7}>
        <Typography fontSize='0.9rem'>{label}</Typography>
      </Grid>
      <Grid item xs={5}>
        <Typography fontSize='0.9rem' align='right' className='fhbf-print-field-padding-small'>
          {value}
        </Typography>
      </Grid>
    </>
  );
}

export default OptionField;
